import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { AdminPanel } from '@ui/pages/manage'
import { RouteNamesEnum } from '@ui/router/routes'

export const AdminRoutes = () => {
  return {
    name: RouteNamesEnum.ADMIN,
    path: '/admin',
    element: <AdminPanel />,
    handle: {
      crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to="/admin" label="Administration" />,
    },
  }
}
